import React from 'react';
import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { InfoBox, Input } from '@motorway/mw-highway-code/alpha';

import ModalHeader from 'Components/Modal/Header/ModalHeader';

import LocalTexts from '../DiscoverMWPay.texts.json';

import type { ModalRequestCallbackContentProps } from './ModalRequestCallback.types';

import styles from './ModalRequestCallback.module.scss';

const LocalT = new MDText(LocalTexts.requestCallback);

export const ModalRequestCallbackContent: React.FC<ModalRequestCallbackContentProps> = ({
	defaultValues,
	onSubmit,
	status = 'idle',
}) => {
	const handleInternalOnSubmit = (event: React.FormEvent) => {
		event.preventDefault();

		const formValues = new FormData(event.target as HTMLFormElement);
		const payload = {
			name: formValues.get('name')?.toString() ?? '',
			phone: formValues.get('phone')?.toString() ?? '',
		};

		void onSubmit?.(payload);
	};

	if (status === 'success') {
		return (
			<div className={styles.wrapper}>
				<ModalHeader title={LocalT.translate('success.heading')} />

				<p>{LocalT.translate('success.secondary')}</p>
			</div>
		);
	}

	return (
		<form className={styles.wrapper} onSubmit={handleInternalOnSubmit}>
			<ModalHeader title={LocalT.translate('open.heading')} />

			<p>
				{LocalT.translate('open.primary')}
				<br /> {LocalT.translate('open.secondary')}
			</p>

			{status === 'error' && (
				<InfoBox
					content={LocalT.translate('error.content')}
					heading={LocalT.translate('error.heading')}
					variant="error"
				/>
			)}

			{status === 'invalidPhone' && (
				<InfoBox
					content={LocalT.translate('invalidPhone.content')}
					heading={LocalT.translate('invalidPhone.heading')}
					variant="error"
				/>
			)}

			<Input
				fullWidth
				required
				showLabel
				defaultValue={defaultValues?.name}
				formProps={{
					input: {
						inputMode: 'text',
						name: 'name',
						pattern: `^[a-zA-Z' ]*$`,
					},
					onInput(e) {
						e.currentTarget.setCustomValidity('');
					},
					onInvalid(e) {
						e.currentTarget.setCustomValidity('Please provide correct name');
					},
				}}
				id="request-name"
				label="Name"
			/>

			<Input
				fullWidth
				required
				showLabel
				defaultValue={defaultValues?.phone}
				formProps={{
					input: {
						inputMode: 'numeric',
						name: 'phone',
						pattern: '[0-9]*',
					},
					onInput(e) {
						e.currentTarget.setCustomValidity('');
					},
					onInvalid(e) {
						e.currentTarget.setCustomValidity('Please provide correct phone number');
					},
				}}
				id="request-phone"
				intent={status === 'invalidPhone' ? 'error' : undefined}
				label="Contact number"
			/>

			<Button
				fullWidth
				disabled={status === 'loading'}
				icon="chevron"
				label={LocalT.translate('submit')}
				loading={status === 'loading'}
				type="submit"
			/>
		</form>
	);
};
